import { ConfigProvider } from 'antd';
import type { ReactNode } from 'react';
import styles from './FilterRow.module.scss';

// equivalent of middle size
const FILTER_ROW_THEME = {
  components: {
    Input: { controlHeight: 32 },
    Button: { controlHeight: 32 },
  },
};

type Props = { children: ReactNode };

export const FilterRow = ({ children }: Props) => (
  <ConfigProvider theme={FILTER_ROW_THEME}>
    <div className={styles.row}>{children}</div>
  </ConfigProvider>
);

export const FilterRowSpacer = () => <span className={styles.spacer} />;
